import { List, ListItem, Box } from "@mui/material";

const TaskStateList = ({ taskStateWidth = "100%", data }) => {
  return (
    <List sx={{ width: taskStateWidth, display: "flex", flexDirection: "column", gap: "8px", maxWidth: "346px" }}>
      <ListItem sx={{ padding: "0" }}>
        <Box
          sx={{
            display: "flex",
            gap: "16px",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: "16px",
              alignItems: "center",
            }}
          >
            <Box sx={{ width: "10px", height: "10px", background: "var(--red)", borderRadius: "50%" }}></Box>
            <Box>Сообщений `Пожар` за смену:</Box>
          </Box>

          <Box>{data.fireMessagesAmount}</Box>
        </Box>
      </ListItem>
      <ListItem sx={{ padding: "0" }}>
        <Box
          sx={{
            display: "flex",
            gap: "16px",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: "16px",
              alignItems: "center",
            }}
          >
            <Box sx={{ width: "10px", height: "10px", background: "var(--orange)", borderRadius: "50%" }}></Box>
            <Box>Ложных сообщений `Пожар` за смену:</Box>
          </Box>

          <Box>{data.falseFireMessagesAmount}</Box>
        </Box>
      </ListItem>
    </List>
  );
};
export default TaskStateList;
